import PolicyTypeTable from "./View/PolicyTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const PolicyType = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_policytype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <PolicyTypeTable /> : ""}</>
  );
};

export default PolicyType;
